import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DesignSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DesignSVG;
